import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ql-formats" }
const _hoisted_2 = {
  class: "ql-header",
  defaultValue: "0",
  style: {"width":"7.5rem"}
}
const _hoisted_3 = { value: "0" }
const _hoisted_4 = { value: "3" }
const _hoisted_5 = { value: "2" }
const _hoisted_6 = { value: "1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Editor = _resolveComponent("Editor")!

  return (_openBlock(), _createBlock(_component_Editor, {
    modelValue: _ctx.currentValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentValue) = $event)),
    editorStyle: "height: 250px",
    onTextChange: _ctx.onChange
  }, {
    toolbar: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createElementVNode("select", _hoisted_2, [
          _createElementVNode("option", _hoisted_3, _toDisplayString(_ctx.$t("Squeeze.Validation.Email.FontSizeNormal")), 1),
          _createElementVNode("option", _hoisted_4, _toDisplayString(_ctx.$t("Squeeze.Validation.Email.FontHeadline1")), 1),
          _createElementVNode("option", _hoisted_5, _toDisplayString(_ctx.$t("Squeeze.Validation.Email.FontHeadline2")), 1),
          _createElementVNode("option", _hoisted_6, _toDisplayString(_ctx.$t("Squeeze.Validation.Email.FontHeadline3")), 1)
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("select", { class: "ql-font" }, [
          _createElementVNode("option"),
          _createElementVNode("option", { value: "serif" }),
          _createElementVNode("option", { value: "monospace" })
        ], -1))
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "ql-formats" }, [
        _createElementVNode("button", {
          class: "ql-bold",
          type: "button"
        }),
        _createElementVNode("button", {
          class: "ql-italic",
          type: "button"
        }),
        _createElementVNode("button", {
          class: "ql-underline",
          type: "button"
        })
      ], -1)),
      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "ql-formats" }, [
        _createElementVNode("select", { class: "ql-color" }),
        _createElementVNode("select", { class: "ql-background" })
      ], -1)),
      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "ql-formats" }, [
        _createElementVNode("button", {
          class: "ql-list",
          value: "ordered",
          type: "button"
        }),
        _createElementVNode("button", {
          class: "ql-list",
          value: "bullet",
          type: "button"
        })
      ], -1)),
      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "ql-formats" }, [
        _createElementVNode("button", {
          class: "ql-align",
          value: "",
          type: "button"
        }),
        _createElementVNode("button", {
          class: "ql-align",
          value: "center",
          type: "button"
        }),
        _createElementVNode("button", {
          class: "ql-align",
          value: "right",
          type: "button"
        }),
        _createElementVNode("button", {
          class: "ql-align",
          value: "justify",
          type: "button"
        })
      ], -1)),
      _cache[6] || (_cache[6] = _createElementVNode("span", { class: "ql-formats" }, [
        _createElementVNode("button", {
          class: "ql-link",
          type: "button"
        }),
        _createElementVNode("button", {
          class: "ql-image",
          type: "button"
        }),
        _createElementVNode("button", {
          class: "ql-code-block",
          type: "button"
        })
      ], -1)),
      _cache[7] || (_cache[7] = _createElementVNode("span", { class: "ql-formats" }, [
        _createElementVNode("button", {
          class: "ql-clean",
          type: "button"
        })
      ], -1))
    ]),
    _: 1
  }, 8, ["modelValue", "onTextChange"]))
}